export default __webpack_public_path__ + "static/media/bg-group-polisport-offroad.png.e48b3351.png";